import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-h-primary-50 border py-2" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "container mx-auto flex w-12/12 sm:w-10/12 lg:w-6/12 justify-center my-10" }
const _hoisted_4 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_NewMaterialForm = _resolveComponent("NewMaterialForm")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BreadcrumbComponent, {
          home: _ctx.home,
          items: _ctx.items
        }, null, 8, ["home", "items"])
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.type === 'add' || _ctx.type === 'edit')
          ? (_openBlock(), _createBlock(_component_NewMaterialForm, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}